import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { ScrollIntoView, Button } from '@grandvisionhq/common';
import { Text, Heading } from '@grandvisionhq/elements';
import { Alert, Spinner } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import CategoryGroup from '../../../CategoryGroup/CategoryGroup.js';
import OrderListItemContainer from '../OrderListItem/OrderListItemContainer.js';

const OrderList = ({ error , labels , loading , orders , ordersLoaded , totalOrders , showOrderDate , onLoadMoreClick , onContactLinkClick ,  })=>{
    const { getLabel  } = useIntl();
    const contactElement = labels.contactText ? /*#__PURE__*/ React.createElement(Text, {
        onClick: onContactLinkClick
    }, labels.contactText) : null;
    if (error) {
        return /*#__PURE__*/ React.createElement(ScrollIntoView, null, /*#__PURE__*/ React.createElement(Alert, {
            variant: "error",
            className: "alert-m-default"
        }, labels.error));
    }
    if (!orders) {
        return /*#__PURE__*/ React.createElement(Spinner, {
            "aria-label": getLabel('common.loadingText')
        });
    }
    if (totalOrders < 1 && !loading) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, null, labels.noHistory), contactElement, /*#__PURE__*/ React.createElement(Heading, {
            component: "h4",
            variant: "smallest"
        }, labels.productCategories), /*#__PURE__*/ React.createElement(CategoryGroup, null));
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "order-list"
    }, contactElement, orders.map((order)=>/*#__PURE__*/ React.createElement(OrderListItemContainer, swcHelpers.extends({}, order, {
            key: order.orderNumber,
            showOrderDate: showOrderDate
        }))
    ), totalOrders < 1 && loading ? /*#__PURE__*/ React.createElement(Spinner, {
        "aria-label": getLabel('common.loadingText')
    }) : /*#__PURE__*/ React.createElement("div", {
        className: "order-list__pager"
    }, /*#__PURE__*/ React.createElement(Text, {
        className: "order-list__pager-label"
    }, labels.progressLabel), ordersLoaded < totalOrders && /*#__PURE__*/ React.createElement(Button, {
        "data-t": "load-more",
        className: "order-list__pager-button",
        caption: labels.loadMore,
        onClick: onLoadMoreClick,
        isLoading: loading,
        variant: "outline",
        size: "small"
    })));
};

export { OrderList as default };
//# sourceMappingURL=OrderList.js.map
